

var addValidParam = require('../util').addValidParam;

function returnWPSParams(checkoutCart, checkoutSession, returnToMerchantMethod, is_cart_upload_flow) {
    var params = {};
    var customData = checkoutCart.get('purchase.custom');

    if (returnToMerchantMethod === 'POST') {
        var invoice = checkoutCart.get('purchase.invoice');
        // TODO: find out why we get postbackData as undefined
        // UPDATE: couldn't reproduce an issue on the stage for now
        if (checkoutSession.postbackData) {
            params = checkoutSession.postbackData;
        }
        addValidParam(params, 'custom', customData);
        addValidParam(params, 'invoice', invoice);
    } else {
        var transactionDetail = checkoutSession.transactionDetails;

        if (transactionDetail) {
            addValidParam(params, 'tx', transactionDetail.id);
            addValidParam(params, 'st', transactionDetail.state);

            if (transactionDetail.amount) {
                addValidParam(params, 'amt', transactionDetail.amount.total);
                addValidParam(params, 'cc', transactionDetail.amount.currency);
            }
        }

        // Cart uploads can have more than one item so we don't add any in return URL
        if (!is_cart_upload_flow) {
            var itemDetail = checkoutSession.get('itemsList.0');
            if (itemDetail) {
                addValidParam(params, 'item_name', itemDetail.name);
                addValidParam(params, 'item_number', itemDetail.sku);
            }
        }

        addValidParam(params, 'cm', customData);
    }
    return params;
}

/**
 * this API function is used by hermesnodeweb/public/pages/xo-end and xoonboardingnodeweb/public/pages/xo-end
 * Create params to return back to the merchant after clicking on "Return to merchant" on the Done page.
 * buy-now and cart-upload params are slightly different: given cart-upload might have multiple items,
 * we don't add the item name/number for cart-uploads.
 *
 * Example of returned params for GET method:
 * {
 *    amt: "16.00"
 *    cc: "USD"
 *    cm: "WPS IS @ WEIRD"
 *    item_name: "Mango # Shake"
 *    item_number: "2211335544"
 *    st: "Completed"
 *    tx: "2DD97043CY7805945"
 * }
 * Example of returned params for POST method:
 * {
 *    custom: "WPS IS @ WEIRD"
 *    invoice: "MyInvoiceID"
 * }
 * @param {Object (angular model)} cart model
 * @param {Object (angular model)} session model
 * @param {String} http method, either "POST" or "GET"
 * @param {String} feature type (WPS only for now)
 * @param {Boolean} flag that indicates if it's a cart upload or not
 * @returns {object} params to pass back to the merchant
*/
module.exports = {
    $returnParams: function $returnParams(checkoutCart, checkoutSession, returnToMerchantMethod, feature, is_cart_upload_flow) {
        if (feature === 'WPS') {
            return returnWPSParams(checkoutCart, checkoutSession, returnToMerchantMethod, is_cart_upload_flow);
        }
        return {};
    }
};


/*****************
 ** WEBPACK FOOTER
 ** ./components/xo-page-components/src/returnParams/index.js
 ** module id = 433
 ** module chunks = 1
 **/